import { ChangeDetectionStrategy, Component, input } from "@angular/core";

@Component({
  selector: "ui-title-block",
  standalone: true,
  template: `
    <div class="title-block text-center">
      @if (subtitle()) {
        <div class="it-subtitle">
          {{ subtitle() }}
        </div>
      }
      <h1 style="font-family: 'Blacker Pro Text', var(--blacker-pro-text) !important">{{ title() }}</h1>
      @if (linkText()) {
        <div class="login-link">
          {{ linkPrefix() }} <a [href]="linkHref()">{{ linkText() }}</a>
        </div>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiTitleBlockComponent {
  title = input.required<string>();
  subtitle = input<string>();
  linkPrefix = input<string>();
  linkText = input<string>();
  linkHref = input<string>("#");
}
